import React from 'react';

import ProcurementModalContent from './ProcurementModalContent';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ProcurementModal(props) {
    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={$t('Procurement Info')} close={props.onClose}></ModalHeader>
            <div className="tw-rounded-b">
                {!props.fetched && props.loading && <LoadingSpinner />}
                {!props.fetched && !props.loading && (
                    <div className="modal__form-container">
                        <label className="modal__msg modal__error-text-color">{$t('Data not fetched')}</label>
                    </div>
                )}
                {props.fetched && <ProcurementModalContent procurement={props.procurement} downloadAttachmentUrl={props.downloadAttachmentUrl} />}
            </div>
        </Modal>
    );
}
